import { TweenLite, Power2 } from "gsap";
import "gsap/src/uncompressed/plugins/ScrollToPlugin";

class ScrollTo {
  constructor() {
    this.duration = 1.5;
    this.maxTop = 200;
    this.headerScroll = document.querySelector(".header--scroll");
    this.links = document.querySelectorAll(".fonc__nav__ul__link");
    this.menuSticky = false;
    this.initEvents();
  }

  /** Events onChange sur les selects */
  initEvents() {
    Array.from(this.links, (link, index) => {
      link.addEventListener("click", () => {
        this.onDown(index);
      });
    });
    window.addEventListener("scroll", e => {
      this.navFixed(this.headerScroll, this.maxTop);
    });
    this.navFixed(this.headerScroll, this.maxTop);
  }

  navFixed(el, maxTop) {
    if (window.scrollY >= maxTop) {
      if (!this.menuSticky) {
        this.menuSticky = true;
        TweenLite.to(el, 0.7, {
          y: 0,
          force3D: true,
          ease: Power2.easeInOut
        });
      }
    } else {
      if (this.menuSticky) {
        this.menuSticky = false;
      }

      if (window.scrollY === 0) {
        TweenLite.to(el, 0, {
          y: -300 + "px",
          force3D: true,
          ease: Power2.easeInOut
        });
      }
    }
  }

  onDown(index) {
    TweenLite.to(window, this.duration, {
      scrollTo: "#section-" + index,
      ease: Power2.easeInOut
    });
  }
}

export default ScrollTo;



// WEBPACK FOOTER //
// ./src/js/components/ScrollTo.js